/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { BsPlayFill } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { useRecoilValue } from "recoil";
import { SettingsHelpVideosAtom } from "../../atoms/SettingsHelpVideos";
import { HelpVideo } from "../HelpVideo";
import { useModal } from "../Modal/Modal";
import WhatsNewButton from "../WhatsNewButton";

const Wrapper = styled.div`
  width: calc(100% - 60px);
  background: #ffffff;
  border-bottom: 1px solid #dddddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  position: fixed;

  @media screen and (max-width: 560px) {
    width: 100%;

    padding: 20px 77px 20px 25px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .icon-button {
    width: 42px;
    height: 42px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #fff;

    border-radius: 5px;
    border: 1px solid #dddddd;

    cursor: pointer;

    svg {
      width: 20px;
      height: 20px;

      color: #555555;
    }
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  cursor: default;
`;

const TopBarTitle = styled.div`
  font-size: 20px;
  letter-spacing: 0.3px;
  font-weight: 600;
  color: #333333;
`;

const TopBarSubTitle = styled.div`
  font-size: 14px;
  letter-spacing: 0.2px;
  color: #707070;
`;

const TooltipText = styled.span`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #ffffff;
`;

const TopBar = (): JSX.Element => {
  const { helpTitle, helpContext } = useRecoilValue(SettingsHelpVideosAtom);
  const modalHandler = useModal();

  useEffect(() => {
    global.ps_config = {
      workspace_id: "f8ea5b12-675a-43e1-af7e-19f0464c62d8",
    };

    let script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", "https://cdn.loopedin.io/js/widget.js?v=0.8");
    document.getElementsByTagName("head")[0].appendChild(script);
  }, []);

  return (
    <Wrapper>
      <TitleContainer>
        <TopBarTitle>Settings</TopBarTitle>
      </TitleContainer>
      <ButtonsContainer>
        <div
          className="icon-button"
          onClick={() =>
            modalHandler.pushModal(
              <HelpVideo contextTag={helpContext} />,
              helpTitle
            )
          }
          data-tip
          data-for="openVideo"
        >
          <BsPlayFill />
          <ReactTooltip
            id="openVideo"
            place="bottom"
            effect="solid"
            globalEventOff="click"
            backgroundColor="#333333"
            css={css`
              width: fit-content !important;
              padding: 6px 8px !important;
            `}
          >
            <TooltipText>Watch Quick Help Video</TooltipText>
          </ReactTooltip>
        </div>

        <div
          css={css`
            margin-left: 10px;
          `}
        >
          <WhatsNewButton />
        </div>
      </ButtonsContainer>
    </Wrapper>
  );
};

export default TopBar;
